/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function() {
  // Delay the background and text fade effect for 1 second after page load
  /*setTimeout(function() {
    $('.custom-banner-img-wp').addClass("goDark");
  }, 0); // 1000 ms = 1 second

  setTimeout(function() {
    $('.custom-banner-content').addClass("goBright");
  }, 2000); // 1000 ms = 1 second*/
  
  $($(".shopify_subscriptions_app_block_label")[2]).hide();

  const select = document.querySelector('#billingAddressForm select[name="countryCode"]');
  
  if (select && select.options.length > 0) {
    select.removeChild(select.options[0]);
  } 
});